import i18next from 'i18next';

export const errors = {
  INVALID_SIGNATURE: 'Invalid signature',
  USER_NOT_FOUND: 'User not found',
  NOT_PERSONAL_KEY: 'Not personal key',
} as const;

export function getErrorMessage(error: string | undefined) {
  if (!error) {
    return '';
  }
  if (error === errors.NOT_PERSONAL_KEY) {
    return i18next.t('errors.notPersonalKey');
  }
  return i18next.t('errors.serverError');
}

export function decodeHTMLEntities(html: string) {
  const txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
}
